// src/locales/si/products.js
export const products = {
  // Page titles and navigation
  createNewProduct: 'නව නිෂ්පාදනයක් සාදන්න',
  addNewProductToInventory: 'ඔබේ ඉන්වෙන්ටරිය වෙත නව නිෂ්පාදනයක් එක් කරන්න',
  backToProducts: 'නිෂ්පාදන වෙත ආපසු',
  allProducts: 'සියලුම නිෂ්පාදන',
  addProduct: 'නිෂ්පාදනය එක් කරන්න',
  editProduct: 'නිෂ්පාදනය සංස්කරණය කරන්න',
  deleteProduct: 'නිෂ්පාදනය මකන්න',
  duplicateProduct: 'නිෂ්පාදනය අනුපිටපත් කරන්න',
  viewDetails: 'විස්තර බලන්න',
  
  // Product list page
  manageProductInventory: 'ඔබේ නිෂ්පාදන ඉන්වෙන්ටරිය සහ නාමාවලිය කළමනාකරණය කරන්න',
  loadingProducts: 'නිෂ්පාදන පූරණය වෙමින්',
  loadingProductsDesc: 'කරුණාකර අපි ඔබේ නිෂ්පාදන පූරණය කරන තෙක් රැඳී සිටින්න...',
  unableToLoadProducts: 'නිෂ්පාදන පූරණය කළ නොහැක',
  noProductsFound: 'නිෂ්පාදන හමු නොවීය',
  noProductsFoundDesc: 'ඔබේ වර්තමාන සෙවුම් හා පෙරහන් නිර්ණායක වලට නිෂ්පාදන ගැලපෙන්නේ නැත.',
  noProductsYet: 'තවම නිෂ්පාදන නැත',
  noProductsYetDesc: 'ඔබේ පළමු නිෂ්පාදනය එක් කිරීමෙන් ඔබේ ඉන්වෙන්ටරිය ගොඩනැගීම ආරම්භ කරන්න.',
  addFirstProduct: 'පළමු නිෂ්පාදනය එක් කරන්න',
  priceOptions: 'මිල විකල්ප',
  range: 'පරාසය',
  noPrice: 'මිලක් නැත',
  multiplePrices: 'බහු මිල',
  priceRange: 'මිල පරාසය',
  lowestPrice: 'අඩුම මිල',
  highestPrice: 'ඉහළම මිල',
  startingFrom: 'සිට',
  upTo: 'දක්වා',
  
  // Product list filters
  allTypes: 'සියලුම වර්ග',
  allVisibility: 'සියලුම දෘශ්‍යතාව',
  allStatus: 'සියලුම තත්ත්වය',
  allCategories: 'සියලුම කාණ්ඩ',
  
  // Product list table headers
  productDetails: 'නිෂ්පාදන විස්තර',
  noCategories: 'කාණ්ඩ නැත',
  
  // Product list pagination
  show: 'පෙන්වන්න',
  perPage: 'පිටුවකට',
  showingRecords: 'ප්‍රතිඵල {{total}} න් {{start}} සිට {{end}} දක්වා පෙන්වමින්',
  firstPage: 'පළමු පිටුව',
  previousPage: 'පෙර පිටුව',
  nextPage: 'ඊළඟ පිටුව',
  lastPage: 'අවසාන පිටුව',
  
  // Product actions and confirmations
  confirmStatusChange: 'ඔබට විශ්වාසද "{{productName}}" {{action}} කිරීමට?',
  confirmDuplicate: 'ඔබට විශ්වාසද "{{productName}}" අනුපිටපත් කිරීමට?',
  confirmDelete: 'ඔබට විශ්වාසද "{{productName}}" මකා දැමීමට? මෙම ක්‍රියාව අහෝසි කළ නොහැක.',
  statusUpdateSuccess: '"{{productName}}" {{status}} ලෙස සාර්ථකව සකසන ලදී!',
  statusUpdateFailed: 'නිෂ්පාදන තත්ත්වය යාවත්කාලීන කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.',
  duplicateSuccess: '"{{productName}}" සාර්ථකව අනුපිටපත් කරන ලදී!',
  duplicateFailed: 'නිෂ්පාදනය අනුපිටපත් කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.',
  deleteSuccess: '"{{productName}}" සාර්ථකව මකා දමා ඇත!',
  deleteFailed: 'නිෂ්පාදනය මකා දැමීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.',
  
  // Product status actions
  makeDraft: 'කෙටුම්පත කරන්න',
  makePublic: 'ප්‍රසිද්ධ කරන්න',
  
  // Loading states
  loadingData: 'දත්ත පූරණය වෙමින්',
  loadingDataDesc: 'කරුණාකර අවශ්‍ය දත්ත පූරණය වන තෙක් රැඳී සිටින්න...',
  failedToLoadData: 'අවශ්‍ය දත්ත පූරණය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.',
  
  // Form tabs
  basicInfo: 'මූලික තොරතුරු',
  pricing: 'මිල ගණන් සහ ඉන්වෙන්ටරිය',
  pricingInfo: 'මිල ගණන් තොරතුරු',
  pricingInfoDesc: 'මිල ගණන් සහ වෙළඳසැල-විශේෂිත තොරතුරු සකසන්න',
  images: 'රූප',
  variations: 'විචල්‍යන',
  
  // Basic Information
  basicInformation: 'මූලික තොරතුරු',
  basicInformationDesc: 'ඔබේ නිෂ්පාදනය පිළිබඳ මූලික විස්තර ඇතුළත් කරන්න',
  basicInformationEditDesc: 'ඔබේ නිෂ්පාදනය පිළිබඳ මූලික විස්තර යාවත්කාලීන කරන්න',
  productName: 'නිෂ්පාදන නාමය',
  productNamePlaceholder: 'නිෂ්පාදන නාමය ඇතුළත් කරන්න',
  printableName: 'මුද්‍රණය කළ යුතු නම',
  printableNamePlaceholder: 'waybill මත මුද්‍රණය කිරීමට නම (optional)',
  printableNameHint: 'සකසා ඇත්නම්, නිෂ්පාදන නම වෙනුවට waybill label මත මෙම නම මුද්‍රණය වේ',
  nameRequired: 'නිෂ්පාදන නාමය අවශ්‍යයි',
  
  productType: 'නිෂ්පාදන වර්ගය',
  productTypeShort: 'වර්ගය',
  productTypeRequired: 'නිෂ්පාදන වර්ගය අවශ්‍යයි',
  simpleProduct: 'සරල නිෂ්පාදනය',
  variableProduct: 'විචල්‍ය නිෂ්පාදනය (විචල්‍යන සමඟ)',
  simpleProductShort: 'සරල',
  variableProductShort: 'විචල්‍ය',

  
  description: 'විස්තරය',
  descriptionPlaceholder: 'නිෂ්පාදන විස්තරය ඇතුළත් කරන්න (විකල්ප)',
  
  visibility: 'දෘශ්‍යතාව',
  visibilityRequired: 'දෘශ්‍යතාව අවශ්‍යයි',
  public: 'ප්‍රසිද්ධ',
  draft: 'කෙටුම්පත',
  trash: 'කුණු කූඩය',
  
  brand: 'සන්නාමය',
  selectBrand: 'සන්නාමයක් තෝරන්න (විකල්ප)',
  
  // Categories and Tags
  categories: 'නිෂ්පාදන කාණ්ඩ',
  categoriesShort: 'කාණ්ඩ',
  categoryRequired: 'කරුණාකර කාණ්ඩයක් තෝරන්න',
  chooseCategory: 'නිෂ්පාදන කාණ්ඩයක් තෝරන්න',
  
  tags: 'ටැග්',
  selectTags: 'ටැග් තෝරන්න',
  searchTags: 'ටැග් සොයන්න...',
  noTagsFound: 'ටැග් හමු නොවීය',
  noTagsAvailable: 'ටැග් නොමැත',
  loadingTags: 'ටැග් පූරණය වෙමින්...',
  productTags: 'නිෂ්පාදන ටැග්',
  selectProductTags: 'නිෂ්පාදන ටැග් තෝරන්න',
  tagsSelected: 'ටැග් {{count}} ක් තෝරා ඇත',
  removeTag: 'ටැගය ඉවත් කරන්න',
  
  // Pricing and Inventory
  pricingInventory: 'මිල ගණන් සහ ඉන්වෙන්ටරිය',
  pricingInventoryDesc: 'මිල ගණන්, ඉන්වෙන්ටරිය සහ නිෂ්පාදන මාන සකසන්න',
  basicPricingInfo: 'මූලික මිල ගණන් තොරතුරු',
  basicPricingInfoDesc: 'මූලික මිල ගණන් විස්තර සකසන්න. වෙළඳසැල් මිල ගණන් සහ ඉන්වෙන්ටරිය විචල්‍යයකට අනුව වින්‍යාස කෙරේ.',
  
  buyingPrice: 'මිලදී ගැනීමේ/පිරිවැය මිල',
  barcode: 'බාර්කෝඩය',
  barcodePlaceholder: 'නිෂ්පාදන බාර්කෝඩය ඇතුළත් කරන්න (විකල්ප)',
  
  weight: 'බර',
  length: 'දිග', 
  width: 'පළල',
  height: 'උස',
  
  shopPricingInventory: 'වෙළඳසැල-විශේෂිත මිල ගණන්',
  shopPricingInventoryDesc: 'සෑම වෙළඳසැලක් සඳහාම විවිධ මිල සහ තොග මට්ටම් සකසන්න',
  shopPricingInventoryDescSelect: 'වෙළඳසැල් තෝරන්න සහ සෑම වෙළඳසැලක් සඳහාම මිල ගණන් සකසන්න',
  shopPricing: 'වෙළඳසැල් මිල ගණන්',
  shopPricingDesc: 'මෙම නිෂ්පාදනය විකිණීමට තිබෙන සෑම වෙළඳසැලක් සඳහාම මිල ගණන් සකසන්න',
  salesPrice: 'විකුණුම් මිල',
  salesPriceRequired: 'විකුණුම් මිල අවශ්‍යයි',
  dropshippingPrice: 'ඩ්‍රොප්ෂිපින් මිල',
  dropshippingPriceRequired: 'ඩ්‍රොප්ෂිපර් වෙළඳසැල් සඳහා ඩ්‍රොප්ෂිපින් මිල අවශ්‍යයි',
  dropshipperPricing: 'ඩ්‍රොප්ෂිපර් මිල ගණන්',
  stock: 'තොගය',
  stockRequired: 'තොග ප්‍රමාණය අවශ්‍යයි',
  
  // Opening Stock
  openingStock: 'ආරම්භක තොගය',
  openingStockDesc: 'සෑම ගබඩාවක් සඳහාම ආරම්භක තොග ප්‍රමාණය සකසන්න',
  warehouseStock: 'ගබඩා තොගය',
  openingStockRequired: 'ආරම්භක තොගය අවශ්‍යයි',
  openingStockMinimum: 'ආරම්භක තොගය 0 හෝ වැඩි විය යුතුයි',
  
  // Variations
  productVariations: 'නිෂ්පාදන විචල්‍යන',
  productVariationsDesc: 'සෑම විචල්‍යයක් සඳහාම මිල ගණන් සහ ඉන්වෙන්ටරිය වින්‍යාස කරන්න',
  productVariationsDescFull: 'සෑම විචල්‍යයක් සඳහාම මිල ගණන් සහ ඉන්වෙන්ටරිය වින්‍යාස කරන්න. සෑම විචල්‍යයකටම වෙළඳසැල් හරහා විවිධ මිල ගණන් සහ ගබඩාවල විවිධ තොග මට්ටම් තිබිය හැක.',
  variation: 'විචල්‍යය',
  sku: 'SKU',
  skuPlaceholder: 'SKU ඇතුළත් කරන්න (විකල්ප)',
  skuVariationPlaceholder: 'විචල්‍ය SKU ඇතුළත් කරන්න',
  price: 'මිල',
  variationPriceRequired: 'විචල්‍ය මිල අවශ්‍යයි',
  variationStockRequired: 'විචල්‍ය තොගය අවශ්‍යයි',
  costPrice: 'පිරිවැය මිල',
  variationImage: 'විචල්‍ය රූපය',
  editModeVariationsNote: 'විචල්‍යන වෙත කරන වෙනස්කම් පවතින ID සහ සම්බන්ධතා සංරක්ෂණය කරයි.',
  
  // Variations UI
  variationsGenerated: 'විචල්‍යන {{count}} ක් ජනනය කරන ලදී',
  configureVariations: 'පහත සෑම විචල්‍යයක්ම වින්‍යාස කරන්න:',
  regenerate: 'නැවත ජනනය කරන්න',
  removeSelected: 'තෝරාගත් ඒවා ඉවත් කරන්න ({{count}})',
  bulkActions: 'තොග ක්‍රියා',
  variationsSelected: '{{total}} න් {{selected}} ක් තෝරා ඇත',
  variationNumber: 'විචල්‍යය #{{number}}',
  expand: 'විහිදුවන්න',
  collapse: 'හකුළන්න',
  edit: 'සංස්කරණය කරන්න',
  
  // Bulk Actions
  bulkActionsTitle: 'තොග ක්‍රියා',
  bulkActionsDesc: 'තෝරාගත් විචල්‍යන {{count}} ට වෙනස්කම් යොදන්න',
  shopAssignments: 'වෙළඳසැල් පැවරුම්',
  basicFields: 'මූලික ක්ෂේත්‍ර',
  cancel: 'අවලංගු කරන්න',
  applyToSelected: 'තෝරාගත් ඒවා වෙත යොදන්න',
  bulkActionsApplied: 'තොග ක්‍රියා සාර්ථකව යොදන ලදී',
  bulkActionsError: 'කරුණාකර තොග ක්‍රියා යෙදීමට විචල්‍යන තෝරන්න',
  productsSelected: 'නිෂ්පාදන {{count}} ක් තෝරා ඇත',
  deleteSelected: 'තෝරාගත් ඒවා මකන්න ({{count}})',
  confirmBulkDelete: 'ඔබට විශ්වාසද නිෂ්පාදන {{count}} ක් මකා දැමීමට? මෙම ක්‍රියාව අහෝසි කළ නොහැක.',
  bulkDeleteSuccess: 'නිෂ්පාදන {{count}} ක් සාර්ථකව මකා දමා ඇත!',
  bulkDeleteFailed: 'සමහර නිෂ්පාදන මකා දැමීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.',
  
  // Variations Validation
  noVariationsAvailable: 'විචල්‍යන නොමැත',
  noVariationsMessage: 'විචල්‍යන සෑදීමට, කරුණාකර:',
  goToAttributesStep1: 'යන්න',
  goToAttributesStep2: 'ටැබය වෙත',
  goToAttributesStep3: 'නිෂ්පාදන ගුණාංග එක් කරන්න',
  goToAttributesStep4: 'ගුණාංග අගයන් තෝරන්න',
  goToAttributesStep5: 'ඔබට භාවිතා කිරීමට අවශ්‍ය ගුණාංග සඳහා "විචල්‍යන සඳහා භාවිතා කෙරේ" සක්‍රීය කරන්න',
  goToAttributes: 'ගුණාංග වෙත යන්න',
  noVariationsGenerated: 'විචල්‍යන ජනනය කර නැත',
  noVariationsGeneratedDesc: 'ඔබේ ගුණාංග තේරීම් මත පදනම්ව විචල්‍යන ස්වයංක්‍රීයව ජනනය වනු ඇත.',
  atLeastOneVariationRequired: 'අවම වශයෙන් එක් විචල්‍යයක් අවශ්‍යයි',
  atLeastOneShopRequired: 'විකුණුම් මිලක් සමඟ අවම වශයෙන් එක් වෙළඳසැලක් සක්‍රීය කළ යුතුයි',
  skuValidationInProgress: 'SKU වලංගුකරණය ක්‍රියාත්මක වෙමින්...',
  skuAlreadyInUse: 'මෙම SKU දැනටමත් භාවිතයේ',
  
  // Attributes
  attributes: 'නිෂ්පාදන ගුණාංග',
  selectAttributes: 'ගුණාංග තෝරන්න',
  attributesRequiredForVariable: 'විචල්‍ය නිෂ්පාදන සඳහා අවම වශයෙන් එක් ගුණාංගයක් අවශ්‍යයි',
  attributesVariableDesc: 'තෝරාගත් ගුණාංග නිෂ්පාදන විචල්‍යන ජනනය කිරීමට භාවිතා වනු ඇත',
  attributesDesc: 'මෙම නිෂ්පාදනයට අදාළ ගුණාංග තෝරන්න',
  attributesVariableEditDesc: 'තෝරාගත් ගුණාංග නිෂ්පාදන විචල්‍යන ජනනය කිරීමට භාවිතා වනු ඇත. වෙනස්කම් පවතින විචල්‍යන වෙත බලපානු ඇත.',
  attributesEditDesc: 'මෙම නිෂ්පාදනය විස්තර කරන ගුණාංග තෝරන්න.',
  variableProductAttributesRequired: 'විචල්‍යන සඳහා විචල්‍ය නිෂ්පාදන වලට අවම වශයෙන් එක් ගුණාංගයක් අවශ්‍යයි.',
  variationAttributesInfo: '"විචල්‍යන සඳහා භාවිතා කෙරේ" ලෙස සලකුණු කර ඇති ගුණාංග නිෂ්පාදන විචල්‍යන ජනනය කරනු ඇත.',
  variationAttributesInfo2: 'ඔබට අවශ්‍ය විචල්‍යන සෑදීමට ගුණාංග අගයන් තෝරාගැනීමට වග බලාගන්න.',
  changesWillUpdateVariations: 'ගුණාංග වෙත කරන වෙනස්කම් පවතින නිෂ්පාදන විචල්‍යන වෙත බලපෑ හැක.',
  
  // Images
  productImages: 'නිෂ්පාදන රූප',
  productImagesDesc: 'ඔබේ නිෂ්පාදනය ප්‍රදර්ශනය කිරීමට රූප උඩුගත කරන්න',
  productImagesRecommendation: 'නිෂ්පාදන රූප සඳහා ඔබේ නිර්දේශ උඩුගත කරන්න.',
  editModeImageNote: 'ඔබට පවතින රූප ප්‍රතිස්ථාපනය කිරීමට හෝ නව ඒවා එක් කිරීමට හැකිය. නිෂ්පාදනය යාවත්කාලීන කරන විට වෙනස්කම් සුරකිනු ලැබේ.',
  editModeInstructions: 'පවතින රූප මත ක්ලික් කිරීමෙන් ඒවා ප්‍රතිස්ථාපනය කරන්න, හෝ හිස් ස්ථාන වෙත නව රූප එක් කරන්න.',
  
  mainImage: 'ප්‍රධාන නිෂ්පාදන රූපය',
  uploadMainImage: 'ප්‍රධාන රූපය උඩුගත කරන්න',
  uploadImages: 'රූප උඩුගත කරන්න',
  clickToUploadMainImage: 'ප්‍රධාන රූපය උඩුගත කිරීමට ක්ලික් කරන්න',
  imageFormats: 'PNG, JPG, JPEG, WEBP 5MB දක්වා',
  invalidImageFormat: 'අවලංගු රූප ආකෘතිය. කරුණාකර PNG, JPG, JPEG හෝ WEBP භාවිතා කරන්න',
  imageTooLarge: 'රූප ගොනුව ඉතා විශාලයි. උපරිම ප්‍රමාණය 5MB වේ',
  
  galleryImages: 'ගැලරි රූප',
  galleryImagesDesc: 'විවිධ කෝණ හෝ විශේෂාංග පෙන්වීමට අතිරේක රූප උඩුගත කරන්න',
  addGalleryImages: 'ගැලරි රූප එක් කරන්න',
  invalidGalleryImages: 'එක් හෝ වැඩි ගැලරි රූප අවලංගු හෝ ඉතා විශාලයි',
  setAsMainImage: 'ප්‍රධාන රූපය ලෙස සකසන්න',
  replaceImage: 'රූපය ප්‍රතිස්ථාපනය කරන්න',
  revertImage: 'රූපය ප්‍රතිවර්තනය කරන්න',
  removeImage: 'රූපය ඉවත් කරන්න',
  mainImageBadge: 'ප්‍රධාන',
  modified: 'වෙනස් කරන ලදී',
  dragDropInstructions: 'උඩුගත කිරීමට ඇදගෙන යන්න සහ අතහරින්න හෝ ගොනු තෝරන්න.',
  maxImagesNote: 'උපරිම රූප {{max}} ක් ඉඩ දෙනු ලැබේ.',
  
  // Form actions
  createProduct: 'නිෂ්පාදනය සාදන්න',
  updateProduct: 'නිෂ්පාදනය යාවත්කාලීන කරන්න',
  productCreatedSuccess: 'නිෂ්පාදනය "{{productName}}" සාර්ථකව සාදන ලදී!',
  productUpdated: 'නිෂ්පාදනය සාර්ථකව යාවත්කාලීන කරන ලදී',
  failedToCreateProduct: 'නිෂ්පාදනය සෑදීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.',
  failedToUpdateProduct: 'නිෂ්පාදනය යාවත්කාලීන කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.',
  failedToLoadProduct: 'නිෂ්පාදනය පූරණය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.',
  
  // Common terms used throughout
  required: 'අවශ්‍යයි',
  optional: 'විකල්ප',
  selectOption: 'විකල්පයක් තෝරන්න',
  
  // Error messages
  someFieldsRequired: 'කරුණාකර සියලු අවශ්‍ය ක්ෂේත්‍ර පුරවන්න',
  invalidPriceValue: 'කරුණාකර වලංගු මිලක් ඇතුළත් කරන්න',
  invalidStockValue: 'කරුණාකර වලංගු තොග ප්‍රමාණයක් ඇතුළත් කරන්න',
  stockMinZero: 'තොගය 0 හෝ වැඩි විය යුතුයි',
  salesPriceRequiredEnabled: 'සක්‍රීය වෙළඳසැල් සඳහා විකුණුම් මිල අවශ්‍යයි',
  
  // Success messages
  productSaved: 'නිෂ්පාදනය සාර්ථකව සුරකින ලදී',
  productDeleted: 'නිෂ්පාදනය සාර්ථකව මකා දමන ලදී',
  
  // Validation messages
  priceMinimum: 'මිල 0 ට වැඩි විය යුතුයි',
  stockMinimum: 'තොගය 0 හෝ වැඩි විය යුතුයි',
  weightMinimum: 'බර 0 ට වැඩි විය යුතුයි',
  dimensionMinimum: 'මාන 0 ට වැඩි විය යුතුයි',
  
  // Product status labels
  active: 'සක්‍රීය',
  inactive: 'අක්‍රීය',
  inStock: 'තොගයේ',
  outOfStock: 'තොගයෙන් පිටත',
  lowStock: 'අඩු තොගයක්',
  
  // Shop integration
  availableInShops: 'වෙළඳසැල් වල ලබා ගත හැක',
  notAvailableInAnyShop: 'මෙම නිෂ්පාදනය කිසිදු වෙළඳසැලක නොමැත',
  shopSpecificPricing: 'වෙළඳසැල-විශේෂිත මිල ගණන් සක්‍රීයයි',
  
  // Attribute and variation helpers
  noAttributesSelected: 'ගුණාංග තෝරාගෙන නැත',
  variationsWillBeGenerated: 'තෝරාගත් ගුණාංග මත පදනම්ව විචල්‍යන ස්වයංක්‍රීයව ජනනය වනු ඇත',
  variationCount: 'විචල්‍යන {{count}} ක් සාදනු ලැබේ',
  
  // Image upload helpers
  dragDropImages: 'මෙහි රූප ඇදගෙන යන්න සහ අතහරින්න, හෝ තේරීමට ක්ලික් කරන්න',
  imageUploadProgress: 'රූප උඩුගත වෙමින්...',
  imageUploadComplete: 'රූප සාර්ථකව උඩුගත කරන ලදී',
  imageUploadFailed: 'සමහර රූප උඩුගත කිරීමට අසමත් විය',
  
  // Bulk actions (for future use)
  selectAll: 'සියල්ල තෝරන්න',
  deselectAll: 'සියල්ල තේරීම ඉවත් කරන්න',
  bulkEdit: 'තොග සංස්කරණය',
  bulkDelete: 'තොග මකා දැමීම',
  
  // Filters and search
  searchProducts: 'නිෂ්පාදන සොයන්න...',
  filterByCategory: 'කාණ්ඩය අනුව පෙරන්න',
  filterByBrand: 'සන්නාමය අනුව පෙරන්න',
  filterByStatus: 'තත්ත්වය අනුව පෙරන්න',
  sortByName: 'නම අනුව අනුපිළිවෙල කරන්න',
  sortByPrice: 'මිල අනුව අනුපිළිවෙල කරන්න',
  sortByStock: 'තොගය අනුව අනුපිළිවෙල කරන්න',
  sortByDate: 'දිනය අනුව අනුපිළිවෙල කරන්න',
  
  // General information
  generalInformation: 'සාමාන්‍ය තොරතුරු',
  pricingInformation: 'මිල ගණන් තොරතුරු',
  inventoryInformation: 'ඉන්වෙන්ටරි තොරතුරු',
  shippingInformation: 'නැව්ගත කිරීමේ තොරතුරු',
  
  // Import/Export (for future features)
  importProducts: 'නිෂ්පාදන ආනයනය',
  exportProducts: 'නිෂ්පාදන අපනයනය',
  downloadTemplate: 'අච්චුව බාගන්න',
  uploadFile: 'ගොනුව උඩුගත කරන්න',

  // Bulk Import
  bulkImportProducts: 'තොග ආනයනය',
  bulkImportProductsTitle: 'නිෂ්පාදන තොග වශයෙන් ආනයනය කරන්න',
  bulkImportProductsDesc: 'එකවර නිෂ්පාදන කිහිපයක් සෑදීමට හෝ යාවත්කාලීන කිරීමට Excel ෂීට් එකක් උඩුගත කරන්න',
  columnMapping: 'තීරු සිතියම්කරණය',
  selectShopsStep: 'වෙළඳසැල් තෝරන්න',
  uploadFileStep: 'ගොනුව උඩුගත කරන්න',
  validateProducts: 'නිෂ්පාදන වලංගු කරන්න',
  submitProducts: 'නිෂ්පාදන ඉදිරිපත් කරන්න',
  submitValidProducts: 'වලංගු නිෂ්පාදන {{count}} ඉදිරිපත් කරන්න',
  clearAll: 'සියල්ල හිස් කරන්න',
  retryValidation: 'නැවත වලංගු කරන්න',
  importComplete: 'ආනයනය සම්පූර්ණයි!',
  successfullyImported: 'සාර්ථකව ආනයනය කරන ලදී',
  importMoreProducts: 'තවත් නිෂ්පාදන ආනයනය කරන්න',
  viewProducts: 'නිෂ්පාදන බලන්න',
  failedRows: 'අසාර්ථක පේළි:',
  validRows: 'වලංගු පේළි',
  invalidRows: 'අවලංගු පේළි',
  totalRows: 'මුළු පේළි',
  totalSubmitted: 'මුළු ඉදිරිපත් කළ ගණන',
  validationResults: 'වලංගුකරණ ප්‍රතිඵල',

  // Advanced features
  enableTracking: 'ඉන්වෙන්ටරි ලුහුබැඳීම සක්‍රීය කරන්න',
  trackingEnabled: 'මෙම නිෂ්පාදනය සඳහා ඉන්වෙන්ටරි ලුහුබැඳීම සක්‍රීයයි',
  trackingDisabled: 'මෙම නිෂ්පාදනය සඳහා ඉන්වෙන්ටරි ලුහුබැඳීම අක්‍රීයයි',
  
  digitalProduct: 'ඩිජිටල් නිෂ්පාදනය',
  physicalProduct: 'භෞතික නිෂ්පාදනය',
  downloadableProduct: 'බාගත හැකි නිෂ්පාදනය',
  
  // SEO and marketing
  seoTitle: 'SEO මාතෘකාව',
  seoDescription: 'SEO විස්තරය',
  metaKeywords: 'මෙටා මූල පද',
  
  // Related products
  relatedProducts: 'අදාළ නිෂ්පාදන',
  crossSells: 'හරස් විකුණුම් නිෂ්පාදන',
  upSells: 'ඉහළ විකුණුම් නිෂ්පාදන',
  
  // Reviews and ratings
  customerReviews: 'පාරිභෝගික සමාලෝචන',
  averageRating: 'සාමාන්‍ය ශ්‍රේණිගත කිරීම',
  totalReviews: 'මුළු සමාලෝචන',
  
  // Inventory alerts
  lowStockAlert: 'අඩු තොග අනතුරු ඇඟවීම',
  outOfStockAlert: 'තොගයෙන් පිටත අනතුරු ඇඟවීම',
  setAlertThreshold: 'අනතුරු ඇඟවීම් සීමාව සකසන්න',
  
  // Product history
  productHistory: 'නිෂ්පාදන ඉතිහාසය',
  priceHistory: 'මිල ඉතිහාසය',
  stockHistory: 'තොග ඉතිහාසය',
  lastUpdated: 'අවසන් වරට යාවත්කාලීන කරන ලදී',
  createdDate: 'නිර්මාණ දිනය',
  
  // Warnings and confirmations
  deleteProductWarning: 'ඔබට විශ්වාසද මෙම නිෂ්පාදනය මකා දැමීමට? මෙම ක්‍රියාව අහෝසි කළ නොහැක.',
  unsavedChanges: 'ඔබට සුරකිනු නොලැබූ වෙනස්කම් ඇත. ඔබට විශ්වාසද පිටවීමට?',
  discardChanges: 'වෙනස්කම් ඉවත දමන්න',
  saveChanges: 'වෙනස්කම් සුරකින්න',
  
  // Form sections that might be added later
  advancedOptions: 'උසස් විකල්ප',
  shippingSettings: 'නැව්ගත කිරීමේ සැකසීම්',
  taxSettings: 'බදු සැකසීම්',
  customFields: 'අභිරුචි ක්ෂේත්‍ර',
  
  // Product performance metrics
  totalSales: 'මුළු විකුණුම්',
  revenue: 'ආදායම',
  profitMargin: 'ලාභ ආන්තිකය',
  popularityScore: 'ජනප්‍රියතා ලකුණු',

  configureVariationsEdit: 'සෑම විචල්‍යයක් සඳහාම මිල ගණන් සහ ඉන්වෙන්ටරිය වින්‍යාස කරන්න. වෙනස්කම් පවතින සම්බන්ධතා සංරක්ෂණය කරනු ඇත.',
  editModeStockNotice: 'තොග ප්‍රමාණ වෙන වෙනම කළමනාකරණය කෙරෙන අතර නිෂ්පාදන සංස්කරණය හරහා යාවත්කාලීන නොවේ.',
  currentImage: 'වත්මන් රූපය',
  newImage: 'නව රූපය',
  currentImageWillBeDeleted: 'වත්මන් රූපය මකා දමනු ලැබේ',
  undoDelete: 'අහෝසි කරන්න',
  chooseImageFile: 'මෙම විචල්‍යය සඳහා උඩුගත කිරීමට රූප ගොනුවක් තෝරන්න',
  
  // Additional helpful translations
  existingVariation: 'පවතින විචල්‍යය',
  newVariation: 'නව විචල්‍යය',
  variationUpdated: 'යාවත්කාලීන කරන ලදී',
  variationCreated: 'නව',
  
  // Bulk actions translations
  applyingBulkActions: 'තොග ක්‍රියා යොදමින්...',
  bulkActionsCompleted: 'තොග ක්‍රියා සාර්ථකව සම්පූර්ණ කරන ලදී',
  
  // Image management
  replaceCurrentImage: 'වත්මන් රූපය ප්‍රතිස්ථාපනය කරන්න',
  uploadNewImage: 'නව රූපයක් උඩුගත කරන්න',
  removeCurrentImage: 'වත්මන් රූපය ඉවත් කරන්න',
  keepCurrentImage: 'වත්මන් රූපය තබා ගන්න',
  
  // Validation messages
  variationSkuInUse: 'මෙම විචල්‍ය SKU දැනටමත් භාවිතයේ',
  validatingVariationSku: 'විචල්‍ය SKU වලංගුකරණය වෙමින්...',
  
  // Status indicators
  hasChanges: 'වෙනස්කම් ඇත',
  noChanges: 'වෙනස්කම් නැත',
  unsavedChanges: 'සුරකිනු නොලැබූ වෙනස්කම්',

  // Quantity Offers
  manageOffers: 'දීමනා කළමනාකරණය',
  offersTitle: 'ප්‍රමාණ-ආශ්‍රිත දීමනා',
  addOffer: 'දීමනාවක් එකතු කරන්න',
  saveOffers: 'දීමනා සුරකින්න',
  noOffersYet: 'දීමනා කිසිවක් සකසා නැත',
  offerQuantity: 'ප්‍රමාණය',
  offerCriteria: 'කොන්දේසිය',
  offerUnitPrice: 'ඒකක මිල',
  offerDeliveryOverride: 'බෙදා හැරීමේ ගාස්තු වෙනස් කිරීම',
  criteriaEqual: 'සමාන',
  criteriaGte: 'ට වඩා වැඩි හෝ සමාන',

  // Bundle products
  bundleProduct: 'Bundle Product',
  bundleProductShort: 'Bundle',
  bundles: 'Bundles',
  bundleTab: 'Bundle',
  bundleComponents: 'Bundle Components',
  addComponent: 'Add Component',
  searchComponents: 'Search products to add...',
  componentQty: 'Qty',
  component: 'Component',
  unitValue: 'Unit Value',
  lineDiscount: 'Discount',
  lineTotal: 'Line Total',
  bundlePrice: 'Bundle Price',
  regularTotal: 'Regular Total',
  saving: 'Saving',
  free: 'FREE',
  componentNotAssigned: '{product} is not assigned to this shop',
  typeLocked: 'Bundle type cannot be changed after creation',
  itemsCount: '{count} items',
  noComponentsYet: 'No components added yet. Search above to add products.',
  bundleShopPricing: 'Shop Pricing',
  bulkSetValue: 'Set unit value',
  bulkSetDiscountAmount: 'Set discount amount',
  bulkSetDiscountPercent: 'Set discount %',
  bulkMakeFree: 'Make free (100%)',
  bulkFillFromShopPrice: 'Fill from shop price',
  bulkCopyShop: 'Copy from shop',
  copyFromShop: 'Source shop',
  applyBulk: 'Apply',
  selectedCount: '{count} selected',
  bundleComponentsRequired: 'Add at least one component to the bundle',
  bundleShopRequired: 'Enable at least one shop for the bundle',
  bundleQtyInvalid: 'Component quantity must be greater than 0',
  bundleValueInvalid: 'Unit value must be 0 or more',
  bundleDiscountInvalid: 'Discount must be between 0 and the line value',
  totalWeight: 'මුළු බර',
  availableStock: 'ලබා ගත හැකි තොගය',
  noSku: 'SKU නැත',
  notAssigned: 'පවරා නැත',
  componentStock: 'සංරචක තොගය',
};